import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { SPARTACUS_UK_TIMEZONE } from 'src/constants/spartacus'

dayjs.extend(utc)
dayjs.extend(timezone)

export const CROWS_NEST_UNADOPTED_PAGE_SIZE = 25

/** Keys match Express `UNADOPTED_FEATURE_FILTERS`. */
export const CROWS_NEST_UNADOPTED_FEATURE_FILTERS = Object.freeze([
  { value: '', label: 'Any gap' },
  { value: 'recipes', label: 'Recipes' },
  { value: 'stockTakes', label: 'Stock takes' },
  { value: 'parLevels', label: 'Par levels' },
  { value: 'recipesStockAndPar', label: 'Recipes, stock, and par' },
])

export const CROWS_NEST_UNADOPTED_PLAN_FILTERS = Object.freeze([
  { value: '', label: 'All plans' },
  { value: 'Free', label: 'Free' },
  { value: 'Starter', label: 'Starter' },
  { value: 'Growth', label: 'Growth' },
  { value: 'Pro', label: 'Pro' },
])

/** Individual depth gaps — not the combined recipesStockAndPar flag. */
export const CROWS_NEST_UNADOPTED_GAP_LABELS = Object.freeze({
  recipes: 'Recipes',
  stockTakes: 'Stock takes',
  parLevels: 'Par levels',
})

export function formatUnadoptedGapLabel(unadopted = {}) {
  const labels = Object.entries(CROWS_NEST_UNADOPTED_GAP_LABELS)
    .filter(([key]) => unadopted[key])
    .map(([, label]) => label)
  return labels.length ? labels.join(' · ') : '—'
}

export function formatUnadoptedScopeLabel({
  asOf,
  plan,
  feature,
  recentActivityDays = 90,
} = {}) {
  const planLabel =
    plan && String(plan).trim() ? String(plan).trim() : 'Free and paid'
  const featureLabel = CROWS_NEST_UNADOPTED_FEATURE_FILTERS.find(
    option => option.value && option.value === feature,
  )?.label
  const days = Number(recentActivityDays) || 90
  let when = `Last ${days} days`
  if (asOf) {
    const parsed = dayjs(asOf).tz(SPARTACUS_UK_TIMEZONE)
    if (parsed.isValid()) {
      when = `As of ${parsed.format('D MMM YYYY')}`
    }
  }
  return [when, planLabel, featureLabel].filter(Boolean).join(' · ')
}

export function mapUnadoptedVenue(item) {
  if (!item) return null
  const plan = item.plan || 'Free'
  const paid = Boolean(item.paid)
  return {
    key: item.id,
    id: item.id,
    name: item.name || '—',
    plan,
    paid,
    paidLabel: paid ? 'Paid' : 'Free',
    activeSupplierCount: Number(item.activeSupplierCount) || 0,
    unadopted: item.unadopted || {},
    counts: item.counts || {},
    gapCount: Number(item.gapCount) || 0,
    gapLabel: formatUnadoptedGapLabel(item.unadopted),
  }
}

export function mapUnadoptedVenuesResponse(response = {}) {
  const totals = response.totals || {}
  const filters = response.filters || {}
  const definition = response.definition || {}
  return {
    definition,
    filters,
    asOf: response.asOf || null,
    timezone: response.timezone || null,
    scopeLabel: formatUnadoptedScopeLabel({
      asOf: response.asOf,
      plan: filters.plan,
      feature: filters.feature,
      recentActivityDays: definition.recentActivityDays,
    }),
    totals: {
      venues: Number(totals.venues) || 0,
      paid: Number(totals.paid) || 0,
      free: Number(totals.free) || 0,
      byFeature: totals.byFeature || {},
      byPlan: totals.byPlan || {},
    },
    venues: (Array.isArray(response.venues) ? response.venues : [])
      .map(mapUnadoptedVenue)
      .filter(Boolean),
    pagination: response.pagination || {
      page: 1,
      pageSize: CROWS_NEST_UNADOPTED_PAGE_SIZE,
      total: 0,
      totalPages: 0,
      hasMore: false,
    },
  }
}
